/**
 * CarMark — a small line-art car silhouette used as the household car's
 * identity mark (header). Compact by design: the car is present without eating
 * real estate. Color via currentColor (set with a text-* class). A per-model
 * illustration can replace this later, keyed to oem/model.
 */
export function CarMark({ size = 58, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={(size * 60) / 120}
      viewBox="0 0 120 60"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <g stroke="currentColor" strokeWidth={3.4} strokeLinecap="round" strokeLinejoin="round">
        <path d="M8,44 C6,34 10,30 20,29 L40,28 C45,18 53,14 68,14 L88,14 C100,14 106,19 111,29 L114,30 C117,31 118,35 116,44" />
        <path d="M8,44 H112" />
        <circle cx="36" cy="44" r="9" />
        <circle cx="92" cy="44" r="9" />
      </g>
    </svg>
  );
}
